

const addOrRemoveAddOns = async (requestOption, productHandle, cartItems) => {
  try {
    const response = await fetch(`/products/${productHandle}.js`)
    const data = await response.json()
    cartItems.map((item) => {
      if (item.handle === productHandle) {
        data.variants.map((variant) => {
          if (variant.id === item.variant_id) {
            fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
              body: `id=${variant.id}&quantity=0`,
            }).catch((error) => {
              console.error(error)
            })
          }
        })
      }
    })
  } catch (err) {
    console.log(err)
  }
}

const hideRebuyProductDiscount = (productId, widgetId) => {
  const container = document.querySelector(`#rebuy-widget-${widgetId}`)
  const card = container.querySelector(`.product-id-${productId}`)
  const discountContainer = card.querySelector(
    `.rebuy-product-price.rebuy-has-discount`
  )

  if (discountContainer) {
    discountContainer.classList.toggle("rebuy-disable-discount")
  }
}

const addWidthHeightToImage = (widget, width, height) => {
  const container = document.querySelector(`#rebuy-widget-${widget.id}`)
  if (!container) return
  const images = container.querySelectorAll(".rebuy-product-image img")
  images.forEach((image) => {
    image.setAttribute("width", width)
    image.setAttribute("height", height)
  })
}

const rebuyProductDiscount = (widget) => {
  const container = document.querySelector(`#rebuy-widget-${widget.id}`)
  if (!container) return

  setTimeout(() => {
    const cards = container.querySelectorAll(".rebuy-product-block")
    cards.forEach((card) => {
      if (card.querySelector(".rebuy-discount")) return
      const productId = parseInt(
        card.classList.value
          .split(" ")
          .find((cl) => cl.includes("product-id-"))
          .replace("product-id-", "")
      )
      const product = widget.data.products.find(
        (product) => product.id === productId
      )
      const discountTag = product
        ? product.tags
            .split(", ")
            .find((tag) => tag.toLowerCase().includes("%off"))
        : ""

      const priceContainer = card.querySelector(".rebuy-product-price")
      const discountContainer = card.querySelector(".rebuy-discount-container")
      if (discountContainer) {
        discountContainer.remove()
      }
      priceContainer.classList.remove("rebuy-has-discount")

      if (discountTag) {
        const percent = parseInt(discountTag.replace("%OFF", ""))
        const price = card
          .querySelector(".rebuy-money.sale > span:last-child")
          .innerText.replace("", "")

        if (discountTag.toLowerCase().includes("fake")) {
          const compare = card
            .querySelector(".rebuy-money.compare-at > span:last-child")
            .innerText.replace("", "")

          const discountPercent =
            parseInt((((compare - price) / compare) * 100).toFixed(2)) - 1

          priceContainer.classList.add("rebuy-has-discount-label")
          priceContainer.querySelector("div").insertAdjacentHTML(
            "afterend",
            `
              <span class="rebuy-discount">
                ${discountPercent}%
              </span>
            `
          )
        } else {
          const discount = price * (percent / 100)
          const priceWithDiscount = (price - discount).toFixed(2)

          priceContainer.classList.add("rebuy-has-discount")
          priceContainer.insertAdjacentHTML(
            "afterend",
            `
              <div class="rebuy-discount-container">
                <span class="rebuy-discount-percent">-${percent}%</span>
                <span class="rebuy-discount-price">${priceWithDiscount}</span>
              </div>
            `
          )
        }

        const subscriptionCheckbox = card.querySelector(
          ".subscription-checkbox input"
        )
        if (subscriptionCheckbox) {
          subscriptionCheckbox.setAttribute(
            "onchange",
            `hideRebuyProductDiscount(${productId}, ${widget.id})`
          )
        }
      }
    })
  }, 1000)
}

const promoProductChange = (widget) => {
  rebuyProductDiscount(widget)

  setTimeout(() => {
    let hide = false
    const widgetContainer = document.querySelector(
      `[data-rebuy-id="${widget.id}"]`
    )
    const widgetDiv = document.querySelector(`#rebuy-widget-${widget.id}`)

    if (widgetDiv) {
      hide = widgetDiv.classList.contains("is-hidden")
    } else {
      hide = false
    }

    if (hide) {
      widgetContainer.setAttribute("data-initialized", "false")
    } else {
      widgetContainer.setAttribute("data-initialized", "true")
    }
  }, 500)
}

const insertAfter = (referenceNode, newNode) => {
  if (referenceNode) {
    referenceNode.parentNode?.insertBefore(newNode, referenceNode)
  }
}

const removeVariantByHandle = async (productHandle, cartItems) => {
  try {
    const response = await fetch(`/products/${productHandle}.js`)
    const data = await response.json()
    cartItems.map((item) => {
      if (item.handle === productHandle) {
        data.variants.map((variant) => {
          if (variant.id === item.variant_id) {
            fetch("/cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
              body: `id=${variant.id}&quantity=0`,
            }).catch((error) => {
              console.error(error)
            })
          }
        })
      }
    })
  } catch (err) {
    console.log(err)
  }
}

const removeSubBtnFG = () => {
  const itemInfoContainer = document.querySelectorAll(
    ".rebuy-cart__flyout-item-info"
  )

  itemInfoContainer.forEach((item) => {
    const freeGiftLabel = item.querySelector(
      ".rebuy-cart__flyout-item-discount-message"
    )
    if (freeGiftLabel) {
      item.classList.add("is-gift")
    } else {
      item.classList.remove("is-gift")
    }
  })
}

const smartCartTopBannerSlider = () => {
  new Swiper('.cart-top-banner--container', {
    spaceBetween: 0,
    slidesPerView: "auto",
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    }
  })
}

document.addEventListener("rebuy:smartcart.show", function () {
  if (window.localization?.market.handle !== "us") {
    setTimeout(() => {
      smartCartTopBannerSlider()
    }, 1000);
  }
})

document.addEventListener("rebuy.ready", function (event) {
  removeSubBtnFG()

  if (event.detail.widget.id === "126464") {
    const closeFreeBeltWidget = document.querySelector(
      "#rebuy-widget-126464 .rebuy-modal-close"
    )
    const containerFreeBeltWidget = document.querySelector(
      "#rebuy-widget-126464 .widget-display-popup"
    )
    const contentFreeBeltWidget = document.querySelector(
      "#rebuy-widget-126464 .widget-display-popup .rebuy-widget-content"
    )

    closeFreeBeltWidget.addEventListener("click", () => {
      document
        .getElementById("rebuy-widget-126493")
        .classList.remove("is-hidden")
    })

    containerFreeBeltWidget.addEventListener("click", (event) => {
      if (event.target === containerFreeBeltWidget) {
        document
          .getElementById("rebuy-widget-126493")
          .classList.remove("is-hidden")
      }
    })
  }
})

document.addEventListener("rebuy.productsChange", function (event) {
  if (event.detail.widget.id === "126493") {
    setTimeout(() => {
      const promoWidget = document.querySelector(
        "#rebuy-widget-126464 .widget-display-popup"
      )
      if (promoWidget) {
        const cartPromoWidget = document.getElementById("rebuy-widget-126493")
        const cartPromoContentWidget = cartPromoWidget.querySelector(
          "rebuy-product-block"
        )
        if (promoWidget.classList.contains("is-visible")) {
          cartPromoWidget.classList.add("is-hidden")
        } else {
          if (cartPromoContentWidget) {
            cartPromoWidget.classList.remove("is-hidden")
          }
        }
      }
    }, 500)
  }
  if (
    event.detail.widget.id === "126493" ||
    event.detail.widget.id === "126498"
  ) {
    const removeProductHandle =
      event.detail.widget.data.metadata?.custom?.remove_product
    const cartItems = event.detail.widget.data.cart.items
    if (removeProductHandle) {
      removeVariantByHandle(removeProductHandle, cartItems)
    }
  }
  if (event.detail.widget.id === "164474") {
    const requestOption =
      event.detail.widget.data.metadata?.custom?.request_option
    const productHandle =
      event.detail.widget.data.metadata?.custom?.product_handle
    const cartItems = event.detail.widget.data.cart.items
    if (productHandle) {
      addOrRemoveAddOns(requestOption, productHandle, cartItems)
    }
  }
  currentCartItems = event.detail.widget.data.cart.items
  checkDisableTryNowBtn()
})

document.addEventListener("rebuy:cart.change", function (event) {
  const cartCount = document.querySelectorAll("[data-cart-count]")
  cartCount.forEach((el) => (el.innerText = event.detail.cart.cart.item_count))

  const onlyHasSubProducts = event.detail.cart.cart.items.every(
    (item) => item?.selling_plan_allocation
  )
  const shippingBar = document.querySelector("ig-shipping-progress-container")
  if (shippingBar) {
    if (onlyHasSubProducts) {
      shippingBar.classList.add("is-hidden")
    } else {
      shippingBar.classList.remove("is-hidden")
    }
  }
})

const changeProductQuantity = async (variantId, quantity) => {
  try {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })

    if (!response.ok) {
      console.error("Hubo un problema al eliminar el producto:", error)
    }
  } catch (error) {
    console.error("Hubo un problema al eliminar el producto:", error)
  }
}

const changeLinkedProduct = (type, event) => {
  const container = event.target.closest("[data-key]")

  let linkedProduct = null
  container.classList.forEach((className) => {
    if (className.includes("_linked_product:")) {
      const [_, value] = className.split(":")
      linkedProduct = value
    }
  })

  if (linkedProduct) {
    const linkedProductEl = document.querySelector(
      `.rebuy-cart__flyout-item[data-id='${linkedProduct}']`
    )

    const quantityContainer = linkedProductEl.querySelector(
      ".rebuy-cart__flyout-item-quantity-widget-label"
    )
    const childNodes = quantityContainer.childNodes
    const textNode = Array.from(childNodes).find((node) => {
      return node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== ""
    })
    let quantity = parseInt(textNode ? textNode.nodeValue.trim() : 0)

    const [decrease, increase] = linkedProductEl.querySelectorAll(
      ".rebuy-cart__flyout-item-quantity-widget button"
    )
  
    if (type === "-") {
      quantity--
      if (quantity === 0) {
        // const dataKey = linkedProductEl.getAttribute("data-key")
        // changeProductQuantity(dataKey, quantity)
      } else {
        decrease.click()
      }
    } else if (type === "+") {
      quantity++
      increase.click()
    }
  }
}